import React from "react";

import { Star } from "./Star";
import styles from "./StarRating.scss";

interface RateProps {
  value: number;
  currentRating: number;
  onMouseMove: (
    event: React.MouseEvent<HTMLButtonElement>,
    currentHovering: number
  ) => void;
  onMouseLeave: () => void;
  onClick: () => void;
  hasError: boolean;
  disabled?: boolean;
}

export function Rate({
  value,
  currentRating,
  onMouseMove,
  onMouseLeave,
  onClick,
  hasError,
  disabled,
}: RateProps): JSX.Element {
  const previousRate = value - 1;
  let percentFilled = 0;

  if (currentRating >= value) {
    percentFilled = 1;
  } else if (currentRating > previousRate && currentRating < value) {
    percentFilled = 1 - (value - currentRating);
  }

  return (
    <button
      onClick={onClick}
      onMouseMove={(e) => onMouseMove(e, value)}
      onMouseLeave={onMouseLeave}
      className={styles.rate}
      type="button"
      aria-label={String(value)}
      data-testid={`rate-${value}`}
      id={`rate-${value}`}
      disabled={disabled}
    >
      <Star percentFilled={percentFilled} hasError={hasError} />
    </button>
  );
}
